import Image from "next/image";
import getImageFromStrapi from "../../utils/api/getImageFromStrapi";
import Link from "next/link";
import { InternalLinkIcon, ExternalLinkSimpleIcon } from "../atoms/Icons";
import { Chip } from "../atoms/Chip";
import { formatDate } from "../../utils/utils";
import { prefix } from "../../utils/utils";
export default function CardDefault({
  image,
  title,
  link,
  type,
  isInNews,
  category,
  date,
  translations,
}) {
  return (
    <div className="relative group flex flex-col bg-white h-full rounded-xxxs overflow-hidden media-hover:hover:cursor-pointer">
      <Image
        className="w-full aspect-[3/2] object-cover"
        src={getImageFromStrapi(image)}
        width={420}
        height={280}
        sizes="100vw ,(min-width: 640px) 50vw ,(min-width: 1024px) 33.3vw"
      />
      <div className="flex flex-col justify-between gap-y-20 p-20 h-full">
        <div className="flex flex-col gap-y-20">
          {isInNews && (
            <div className="flex flex-row items-center gap-x-12">
              {category && <Chip text={category} actionable={false} />}
              {date && (
                <span className="text-xxxs font-medium tracking-05">
                  {formatDate(date)}
                </span>
              )}
            </div>
          )}
          {title && (
            <span className="text-s leading-145 tracking-05 font-medium">
              {title}
            </span>
          )}
        </div>
        {type ? (
          <Link
            href={prefix(link)}
            as={prefix(link)}
            target={type === "internal" ? "_self" : "_blank"}
            className="stretched-link btn-link flex items-center gap-8 min-h-32 text-gray-900 rounded-xxxs font-medium text-xxs"
            aria-label={`${translations["read_more"]}: ${title || ""}`}
          >
            <span className="underline decoration-transparent media-hover:group-hover:decoration-gray-900 underline-offset-4 duration-300">
              {translations["read_more"]}
            </span>
            <span className="sr-only">
              {translations["read_more"]}: {title || ""}
            </span>
            {type === "internal" ? (
              <InternalLinkIcon extraClass="stroke-theme-color" />
            ) : (
              <ExternalLinkSimpleIcon extraClass="stroke-theme-color" />
            )}
          </Link>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
